import { inject, InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { DeviceExecutionCommand, DeviceId, DeviceMS, DevicePairingRequest } from '../models/Device';
import { Device } from '../models/DeviceDetail';
import { Execution } from '../models/Execution';
import { UiProfile } from '../models/UiProfile';
import { UpdateDeviceCommand } from '../models/UpdateDeviceCommand';

import { HttpDeviceGateway } from './HttpDeviceGateway';

export interface DeviceGateway {
    fetchDevice(deviceId: string): Observable<Device | null>;
    updateDevice(command: UpdateDeviceCommand): Observable<Execution>;
    refreshDeviceStates(deviceId: string, states: string[]): Observable<Execution[]>;
    getDeviceUI(deviceName: string): Observable<UiProfile>;
    getDeviceById(idDevice: string): Observable<DeviceMS>;
    pairGatewayDevices(req: DevicePairingRequest): Observable<unknown>;
    executeCommand(deviceId: DeviceId, bodyReq: DeviceExecutionCommand): Observable<Execution>;
}

export const DEVICE_GATEWAY = new InjectionToken<DeviceGateway>('DEVICE_GATEWAY', {
    providedIn: 'root',
    factory: () => inject(HttpDeviceGateway),
});
